module.exports = __webpack_public_path__ + "img/horizon.5b0e06c.jpg";